import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { UserInfoService } from 'src/app/common-services/user-info.service';
import { TranslationService } from 'src/app/common-services/translation.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-company-switcher',
  templateUrl: './company-switcher-modal.component.html',
  styleUrls: ['./company-switcher-modal.component.css']
})
export class CompanySwitcherModalComponent implements OnInit, OnDestroy {
  @Input() companies: any[] = [];
  @Output() companySelected = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  userName: string = '';
  userInitials: string = '';
  currentDate: Date = new Date();
  browserLang: string = 'en-US';

  private selectLangSubscription: Subscription;
  private onLangChangeSubscription: Subscription;

  private translations: { [lang: string]: { [key: string]: string } } = {
    'en-US': {
      'Companies': 'Companies',
      'Close': 'Close',
      'Welcome': 'Welcome',
      'Select a General Contractor Company': 'Select a General Contractor Company',
      'Last accessed date': 'Last accessed date'
    },
    'mr-IN': {
      'Companies': 'कंपनीज',
      'Close': 'क्लोज',
      'Welcome': 'वेलकम',
      'Select a General Contractor Company': 'सिलेक्ट अ जनरल कॉन्ट्रॅक्टर कंपनी',
      'Last accessed date': 'लास्ट ॲक्सेस केलेले दिनांक'
    },
    'hi-IN': {
      'Companies': 'कंपनीज',
      'Close': 'क्लोज',
      'Welcome': 'वेलकम',
      'Select a General Contractor Company': 'सिलेक्ट ए जनरल ठेकेदार कंपनी',
      'Last accessed date': 'लास्ट एक्सेस डेट'
    },
    'bn-IN': {
      'Companies': 'কোম্পানিজ',
      'Close': 'ক্লোজ',
      'Welcome': 'ওয়েলকাম',
      'Select a General Contractor Company': 'সিলেক্ট এ জেনারেল কন্ট্রাক্টর কোম্পানি',
      'Last accessed date': 'লাস্ট অ্যাকসেসড ডেট'
    }
  };

  constructor(
    private authuserInfo: UserInfoService,
    private lang: TranslationService,
    private translate: TranslateService
  ) {
    this.browserLang = localStorage.getItem('lang') || this.translate?.currentLang || 'en-US';
    this.selectLangSubscription = this.lang.selectLang.subscribe((l: any) => {
      if (l) this.browserLang = l;
    });
    this.onLangChangeSubscription = this.translate.onLangChange.subscribe((event: any) => {
      if (event && event.lang) this.browserLang = event.lang;
    });
  }

  getTranslated(key: string): string {
    if (!key) return '';
    const lang = this.browserLang || this.translate?.currentLang || localStorage.getItem('lang') || 'en-US';
    return (this.translations[lang] && this.translations[lang][key]) || (this.translations['en-US'] && this.translations['en-US'][key]) || key;
  }

  ngOnInit(): void {
    let userAuthinfo = this.authuserInfo.userInfo();
    if(userAuthinfo && userAuthinfo.Name) {
        this.userName = userAuthinfo.Name;
        let nameParts = this.userName.split(" ");
        let first = nameParts[0] ? nameParts[0][0] : '';
        let last = nameParts.length > 1 ? nameParts[1][0] : '';
        this.userInitials = first + last;
    } else {
        // Fallback or data from passed in
        this.userName = 'User';
        this.userInitials = 'U';
    }
  }

  ngOnDestroy(): void {
    if (this.selectLangSubscription) this.selectLangSubscription.unsubscribe();
    if (this.onLangChangeSubscription) this.onLangChangeSubscription.unsubscribe();
  }

  selectCompany(company: any) {
    this.companySelected.emit(company);
  }

  onCancel() {
    this.cancel.emit();
  }
}
